import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-monthly-rewards',
  templateUrl: './monthly-rewards.page.html',
  styleUrls: ['./monthly-rewards.page.scss'],
})
export class MonthlyRewardsPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
